jQuery(document).ready(function($){
	$('.jq-match-height').matchHeight({
		property: 'min-height'
	});
});